module.exports = __webpack_public_path__ + "static/media/recommend.793efaab.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupon/recommend.png
// module id = 1894
// module chunks = 6